import reducer, { elementHistorySlice } from './slice';

export const { reset } = elementHistorySlice.actions;

export * from './thunks';

export default reducer;
